import { submitFunction } from "../shared/submit";

export const loginRequest = (token) => {
  return {
    type: "LOGIN",
    token: token,
  };
};

export const login = (mobile, password) => {
  return async (dispatch) => {
    let data;
    const _body = JSON.stringify({
      mobile,
      password,
    });

    try {
      data = await submitFunction("/api/admin/signIn", "POST", _body);
    } catch (error) {
      console.log(error);
    }
    if (data) {
      return dispatch(loginRequest(data));
    }
  };
};

export const Logout = () => {
  return {
    type: "LOGOUT",
  };
};

export const todayVisitorsAction = (count) => {
  return {
    type: "TODAY_VISITORS",
    todayVisitors: count,
  };
};

export const yesterdayVisitorsAction = (count) => {
  return {
    type: "YESTERDAY_VISITORS",
    yesterdayVisitors: count,
  };
};

export const totalVisitorsAction = (count) => {
  return {
    type: "TOTAL_VISITORS",
    totalVisitors: count,
  };
};
